// extracted by mini-css-extract-plugin
module.exports = {"quoteBox":"quote_quoteBox__Z9mdA","quoteLogo":"quote_quoteLogo__Pl6ut","quotePara":"quote_quotePara__DBnRr","quoteBy":"quote_quoteBy__eDnle"};